import { createActionsGroup } from 'utils/redux-utils'

export const confirmUnsubscribeFromNewsletterActions = createActionsGroup(
  'NEWSLETTER.UNSUBSCRIBE_CONFIRM',
)
